var exports = {
  "uF": "PermissionComponents.module__stateButtonsContainer___d0gxen",
  "ev": "PermissionComponents.module__stateButton___d0gxen",
  "uz": "PermissionComponents.module__stateButtonDisabled___d0gxen",
  "Jj": "PermissionComponents.module__stateButtonEnabled___d0gxen",
  "c$": "PermissionComponents.module__stateButtonDeny___d0gxen",
  "D5": "PermissionComponents.module__stateButtonNeutral___d0gxen",
  "N$": "PermissionComponents.module__stateButtonAllow___d0gxen",
  "Z9": "PermissionComponents.module__stateButtonInactive___d0gxen",
  "Ds": "PermissionComponents.module__stateDivider___d0gxen",
  "oq": "PermissionComponents.module__overwriteToggle___d0gxen",
  "rt": "PermissionComponents.module__overwriteToggleDense___d0gxen",
  "HC": "PermissionComponents.module__overwriteToggleContent___d0gxen",
  "_O": "PermissionComponents.module__overwriteToggleTitle___d0gxen",
  "Jw": "PermissionComponents.module__overwriteToggleTitleEnabled___d0gxen",
  "Mr": "PermissionComponents.module__overwriteToggleTitleDisabled___d0gxen",
  "GE": "PermissionComponents.module__overwriteToggleDescription___d0gxen",
  "fD": "PermissionComponents.module__overwriteToggleActions___d0gxen",
  "Wk": "PermissionComponents.module__categoryContainer___d0gxen",
  "yj": "PermissionComponents.module__categoryDivider___d0gxen",
  "p8": "PermissionComponents.module__categoryTitle___d0gxen",
  "LW": "PermissionComponents.module__categoryPermissions___d0gxen",
  "wk": "PermissionComponents.module__categoryPermissionsDense___d0gxen",
  "n2": "PermissionComponents.module__categoryPermissionsGrid___d0gxen",
  "HF": "PermissionComponents.module__roleToggle___d0gxen",
  "_y": "PermissionComponents.module__roleToggleDense___d0gxen",
  "vx": "PermissionComponents.module__tooltipTriggerBlock___d0gxen",
  "RO": "PermissionComponents.module__tooltipTriggerInline___d0gxen",
  "Iz": "PermissionComponents.module__roleCategoryContainer___d0gxen",
  "mj": "PermissionComponents.module__roleCategoryDivider___d0gxen",
  "rh": "PermissionComponents.module__roleCategoryTitle___d0gxen",
  "XC": "PermissionComponents.module__roleCategoryPermissions___d0gxen",
  "MC": "PermissionComponents.module__roleCategoryPermissionsDense___d0gxen",
  "bE": "PermissionComponents.module__roleCategoryPermissionsGrid___d0gxen",
};

module.exports = exports;
